// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ProgressDashboard */
.cMPAZebI {
  max-width: 800px;
  margin: 0 auto;
}

.nEgbq2KX {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 0;
  color: #e0e0e0;
}

.ncAPhCxX {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.q3ykSRPe {
  display: flex;
  gap: 8px;
}

.UKl_PQsL,
.qDC4mp5i {
  background: rgba(78, 204, 163, 0.1);
  border: 1px solid rgba(78, 204, 163, 0.3);
  color: #4ecca3;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  transition: background 0.2s;
}

.UKl_PQsL:hover,
.qDC4mp5i:hover {
  background: rgba(78, 204, 163, 0.2);
}

.dpVt5WWr {
  font-size: 18px;
  font-weight: 600;
  color: #e0e0e0;
  margin-bottom: 12px;
}

/* Overall progress */
.wjve9IAi {
  margin-bottom: 24px;
}

.YjV7majH {
  font-size: 14px;
  color: #b0b0b0;
  margin-bottom: 6px;
}

.ZbGwGhiB {
  height: 12px;
  background: #2a2a4a;
  border-radius: 6px;
  overflow: hidden;
}

.KV3g_R4f {
  height: 100%;
  background: linear-gradient(90deg, #4ecca3, #3ab48d);
  border-radius: 6px;
  transition: width 0.5s ease;
}

/* Level section */
.oMy3yFof {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 20px;
  background: #16213e;
  border: 1px solid #2a2a4a;
  border-radius: 12px;
  margin-bottom: 24px;
}

.Qp1jBRw5 {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, #4ecca3, #3ab48d);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.j95TqZAD {
  font-size: 20px;
  font-weight: 700;
  color: #0f0f23;
}

.hdzhmoj1 {
  flex: 1;
  min-width: 0;
}

.BWgxGmtC {
  font-size: 16px;
  font-weight: 600;
  color: #e0e0e0;
  margin-bottom: 6px;
}

.PsILvukL {
  height: 6px;
  background: #2a2a4a;
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 4px;
}

.iUznFBIr {
  height: 100%;
  background: #4ecca3;
  border-radius: 3px;
  transition: width 0.5s ease;
}

.sSs0dLsW {
  font-size: 12px;
  color: #888;
}

/* Stats grid */
.pjsUyiaY {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 24px;
}

.kHkQPAPi {
  text-align: center;
  padding: 16px 8px;
  background: #16213e;
  border: 1px solid #2a2a4a;
  border-radius: 8px;
}

.zn2kMyIq {
  font-size: 24px;
  font-weight: 700;
  color: #4ecca3;
}

.CKPOunuY {
  font-size: 12px;
  color: #888;
  margin-top: 2px;
}

/* Streak */
.mu7J_RfH {
  padding: 16px 20px;
  background: #16213e;
  border: 1px solid #2a2a4a;
  border-radius: 12px;
  margin-bottom: 24px;
}

.hH9V9if9 {
  display: flex;
  gap: 32px;
  margin-bottom: 16px;
}

.R_1U1J62,
.Ov8QijGQ {
  text-align: center;
}

.aj1bZ2wO {
  display: block;
  font-size: 32px;
  font-weight: 700;
  color: #4ecca3;
}

.hXd74Nu_ {
  font-size: 12px;
  color: #888;
}

.IFxthpIN {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.pUIqtZu3 {
  text-align: center;
}

.ADwMiBd1 {
  font-size: 11px;
  color: #888;
  margin-bottom: 4px;
}

.ljUIhwrd {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #2a2a4a;
  margin: 0 auto;
}

.hajjwVvK {
  background: #4ecca3;
}

/* Achievement grid */
.NECS1Qxz {
  margin-bottom: 24px;
}

.MWjwoYbT {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 10px;
}

.JmlOb8bA {
  text-align: center;
  padding: 12px 8px;
  background: #16213e;
  border: 1px solid #2a2a4a;
  border-radius: 8px;
  opacity: 0.4;
  cursor: default;
  transition: opacity 0.2s;
  overflow: hidden;
}

.JmlOb8bA:hover {
  opacity: 0.6;
}

.ndHklO4X {
  opacity: 1;
  border-color: #4ecca3;
  position: relative;
}

.ndHklO4X:hover {
  opacity: 1;
}

.ndHklO4X .j0fvtZ5S {
  position: absolute;
  top: 4px;
  right: 4px;
  opacity: 0;
  transition: opacity 0.2s;
}

.ndHklO4X:hover .j0fvtZ5S {
  opacity: 1;
}

.hoATjGPE {
  font-size: 28px;
  margin-bottom: 4px;
}

.OVGSNu91 {
  font-size: 11px;
  color: #b0b0b0;
  line-height: 1.3;
}

/* Module progress rows */
.dz2CncER {
  margin-bottom: 24px;
}

.M0UMPhyv {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.Uh2aPNTj {
  flex: 0 0 200px;
  font-size: 14px;
  color: #b0b0b0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.qyu50iKh {
  flex: 1;
  height: 6px;
  background: #2a2a4a;
  border-radius: 3px;
  overflow: hidden;
}

.b2acV23W {
  height: 100%;
  background: #4ecca3;
  border-radius: 3px;
  transition: width 0.3s;
}

.nubRmre5 {
  flex: 0 0 40px;
  font-size: 12px;
  color: #888;
  text-align: right;
}

/* Achievement Popup */
.NkjMmxYC {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: Cx6M33Yg 0.3s ease;
}

.cls8n1NV {
  background: #16213e;
  border: 2px solid #4ecca3;
  border-radius: 16px;
  padding: 32px 40px;
  text-align: center;
  max-width: 360px;
  animation: NAM7rxco 0.4s ease;
}

._rDaUFSw {
  font-size: 56px;
  margin-bottom: 8px;
}

.jHGasSob {
  font-size: 14px;
  color: #4ecca3;
  font-weight: 600;
  margin-bottom: 8px;
}

.xtXhQBpg {
  font-size: 22px;
  font-weight: 700;
  color: #e0e0e0;
  margin-bottom: 4px;
}

.Lq73Cmq_ {
  font-size: 14px;
  color: #888;
  margin-bottom: 12px;
}

.ysZEEfho {
  font-size: 18px;
  font-weight: 700;
  color: #4ecca3;
  margin-bottom: 16px;
}

.ooYlLMpp {
  padding: 10px 28px;
  background: #4ecca3;
  color: #0f0f23;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.ooYlLMpp:hover {
  background: #3ab48d;
}

.lCfimCFw {
  font-size: 12px;
  color: #666;
  margin-top: 8px;
}

/* XP floating animation */
.Ijpf5adI {
  position: fixed;
  top: 60px;
  right: 24px;
  font-size: 24px;
  font-weight: 700;
  color: #4ecca3;
  pointer-events: none;
  z-index: 999;
  animation: AU8LwcZB 1.5s ease forwards;
}

@keyframes Cx6M33Yg {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes NAM7rxco {
  from { transform: scale(0.7); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

@keyframes AU8LwcZB {
  0% { opacity: 1; transform: translateY(0); }
  70% { opacity: 1; }
  100% { opacity: 0; transform: translateY(-40px); }
}

/* Responsive: 800px breakpoint */
@media (max-width: 800px) {
  .cMPAZebI {
    padding: 0 8px;
  }

  .nEgbq2KX {
    font-size: 22px;
  }

  .pjsUyiaY {
    grid-template-columns: repeat(2, 1fr);
  }

  .hH9V9if9 {
    gap: 24px;
  }

  .IFxthpIN {
    gap: 4px;
  }

  .MWjwoYbT {
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
  }

  .M0UMPhyv {
    gap: 8px;
  }

  .Uh2aPNTj {
    min-width: 100px;
    font-size: 12px;
  }

  .cls8n1NV {
    width: 90vw;
    max-width: 340px;
    padding: 24px 16px;
  }
}

/* Responsive: 480px phone breakpoint */
@media (max-width: 480px) {
  .nEgbq2KX {
    font-size: 20px;
  }

  .ncAPhCxX {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .pjsUyiaY {
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }

  .kHkQPAPi {
    padding: 10px 6px;
  }

  .zn2kMyIq {
    font-size: 20px;
  }

  .oMy3yFof {
    padding: 12px;
  }

  .Qp1jBRw5 {
    width: 40px;
    height: 40px;
  }

  .j95TqZAD {
    font-size: 16px;
  }

  .hH9V9if9 {
    gap: 16px;
  }

  .aj1bZ2wO {
    font-size: 24px;
  }

  .MWjwoYbT {
    grid-template-columns: repeat(3, 1fr);
    gap: 6px;
  }

  .hoATjGPE {
    font-size: 22px;
  }

  .OVGSNu91 {
    font-size: 10px;
  }

  .Uh2aPNTj {
    flex: 0 0 auto;
    min-width: 0;
    max-width: 120px;
    font-size: 11px;
  }

  .cls8n1NV {
    width: 92vw;
    padding: 20px 12px;
  }

  ._rDaUFSw {
    font-size: 40px;
  }

  .xtXhQBpg {
    font-size: 18px;
  }

  .Ijpf5adI {
    right: 12px;
    font-size: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Progress.module.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,eAAe;AACf;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EAEE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EAEE,UAAU;EACV,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,6BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,sCAAqC;AACvC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,qBAAqB,EAAE,UAAU,EAAE;EAC1C,KAAK,mBAAmB,EAAE,UAAU,EAAE;AACxC;;AAEA;EACE,KAAK,UAAU,EAAE,wBAAwB,EAAE;EAC3C,MAAM,UAAU,EAAE;EAClB,OAAO,UAAU,EAAE,4BAA4B,EAAE;AACnD;;AAEA,iCAAiC;AACjC;EACE;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,qCAAqC;IACrC,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA,uCAAuC;AACvC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,8BAA8B;IAC9B,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF","sourcesContent":["/* ProgressDashboard */\n.container {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.title {\n  font-size: 28px;\n  font-weight: 700;\n  margin-bottom: 0;\n  color: #e0e0e0;\n}\n\n.titleRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.exportImport {\n  display: flex;\n  gap: 8px;\n}\n\n.exportBtn,\n.importBtn {\n  background: rgba(78, 204, 163, 0.1);\n  border: 1px solid rgba(78, 204, 163, 0.3);\n  color: #4ecca3;\n  padding: 6px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  transition: background 0.2s;\n}\n\n.exportBtn:hover,\n.importBtn:hover {\n  background: rgba(78, 204, 163, 0.2);\n}\n\n.sectionTitle {\n  font-size: 18px;\n  font-weight: 600;\n  color: #e0e0e0;\n  margin-bottom: 12px;\n}\n\n/* Overall progress */\n.overallSection {\n  margin-bottom: 24px;\n}\n\n.overallLabel {\n  font-size: 14px;\n  color: #b0b0b0;\n  margin-bottom: 6px;\n}\n\n.overallBar {\n  height: 12px;\n  background: #2a2a4a;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.overallFill {\n  height: 100%;\n  background: linear-gradient(90deg, #4ecca3, #3ab48d);\n  border-radius: 6px;\n  transition: width 0.5s ease;\n}\n\n/* Level section */\n.levelSection {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 16px 20px;\n  background: #16213e;\n  border: 1px solid #2a2a4a;\n  border-radius: 12px;\n  margin-bottom: 24px;\n}\n\n.levelBadge {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #4ecca3, #3ab48d);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.levelNumber {\n  font-size: 20px;\n  font-weight: 700;\n  color: #0f0f23;\n}\n\n.levelInfo {\n  flex: 1;\n  min-width: 0;\n}\n\n.levelTitle {\n  font-size: 16px;\n  font-weight: 600;\n  color: #e0e0e0;\n  margin-bottom: 6px;\n}\n\n.xpBar {\n  height: 6px;\n  background: #2a2a4a;\n  border-radius: 3px;\n  overflow: hidden;\n  margin-bottom: 4px;\n}\n\n.xpFill {\n  height: 100%;\n  background: #4ecca3;\n  border-radius: 3px;\n  transition: width 0.5s ease;\n}\n\n.xpLabel {\n  font-size: 12px;\n  color: #888;\n}\n\n/* Stats grid */\n.statsGrid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.statCard {\n  text-align: center;\n  padding: 16px 8px;\n  background: #16213e;\n  border: 1px solid #2a2a4a;\n  border-radius: 8px;\n}\n\n.statValue {\n  font-size: 24px;\n  font-weight: 700;\n  color: #4ecca3;\n}\n\n.statLabel {\n  font-size: 12px;\n  color: #888;\n  margin-top: 2px;\n}\n\n/* Streak */\n.streakSection {\n  padding: 16px 20px;\n  background: #16213e;\n  border: 1px solid #2a2a4a;\n  border-radius: 12px;\n  margin-bottom: 24px;\n}\n\n.streakNumbers {\n  display: flex;\n  gap: 32px;\n  margin-bottom: 16px;\n}\n\n.streakCurrent,\n.streakBest {\n  text-align: center;\n}\n\n.streakValue {\n  display: block;\n  font-size: 32px;\n  font-weight: 700;\n  color: #4ecca3;\n}\n\n.streakLabel {\n  font-size: 12px;\n  color: #888;\n}\n\n.weekCalendar {\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n}\n\n.weekDay {\n  text-align: center;\n}\n\n.weekDayLabel {\n  font-size: 11px;\n  color: #888;\n  margin-bottom: 4px;\n}\n\n.weekDot {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #2a2a4a;\n  margin: 0 auto;\n}\n\n.weekDotActive {\n  composes: weekDot;\n  background: #4ecca3;\n}\n\n/* Achievement grid */\n.achievementsSection {\n  margin-bottom: 24px;\n}\n\n.achievementGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n  gap: 10px;\n}\n\n.achievementCard {\n  text-align: center;\n  padding: 12px 8px;\n  background: #16213e;\n  border: 1px solid #2a2a4a;\n  border-radius: 8px;\n  opacity: 0.4;\n  cursor: default;\n  transition: opacity 0.2s;\n  overflow: hidden;\n}\n\n.achievementCard:hover {\n  opacity: 0.6;\n}\n\n.achievementCardEarned {\n  composes: achievementCard;\n  opacity: 1;\n  border-color: #4ecca3;\n  position: relative;\n}\n\n.achievementCardEarned:hover {\n  opacity: 1;\n}\n\n.achievementCardEarned .achievementShareWrap {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n\n.achievementCardEarned:hover .achievementShareWrap {\n  opacity: 1;\n}\n\n.achievementIcon {\n  font-size: 28px;\n  margin-bottom: 4px;\n}\n\n.achievementName {\n  font-size: 11px;\n  color: #b0b0b0;\n  line-height: 1.3;\n}\n\n/* Module progress rows */\n.modulesSection {\n  margin-bottom: 24px;\n}\n\n.moduleRow {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.moduleLabel {\n  flex: 0 0 200px;\n  font-size: 14px;\n  color: #b0b0b0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.moduleBar {\n  flex: 1;\n  height: 6px;\n  background: #2a2a4a;\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.moduleFill {\n  height: 100%;\n  background: #4ecca3;\n  border-radius: 3px;\n  transition: width 0.3s;\n}\n\n.moduleCount {\n  flex: 0 0 40px;\n  font-size: 12px;\n  color: #888;\n  text-align: right;\n}\n\n/* Achievement Popup */\n.popupOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  animation: fadeIn 0.3s ease;\n}\n\n.popupCard {\n  background: #16213e;\n  border: 2px solid #4ecca3;\n  border-radius: 16px;\n  padding: 32px 40px;\n  text-align: center;\n  max-width: 360px;\n  animation: popIn 0.4s ease;\n}\n\n.popupIcon {\n  font-size: 56px;\n  margin-bottom: 8px;\n}\n\n.popupTitle {\n  font-size: 14px;\n  color: #4ecca3;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.popupName {\n  font-size: 22px;\n  font-weight: 700;\n  color: #e0e0e0;\n  margin-bottom: 4px;\n}\n\n.popupDesc {\n  font-size: 14px;\n  color: #888;\n  margin-bottom: 12px;\n}\n\n.popupXp {\n  font-size: 18px;\n  font-weight: 700;\n  color: #4ecca3;\n  margin-bottom: 16px;\n}\n\n.popupBtn {\n  padding: 10px 28px;\n  background: #4ecca3;\n  color: #0f0f23;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.popupBtn:hover {\n  background: #3ab48d;\n}\n\n.popupCounter {\n  font-size: 12px;\n  color: #666;\n  margin-top: 8px;\n}\n\n/* XP floating animation */\n.xpFloat {\n  position: fixed;\n  top: 60px;\n  right: 24px;\n  font-size: 24px;\n  font-weight: 700;\n  color: #4ecca3;\n  pointer-events: none;\n  z-index: 999;\n  animation: xpFlyUp 1.5s ease forwards;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes popIn {\n  from { transform: scale(0.7); opacity: 0; }\n  to { transform: scale(1); opacity: 1; }\n}\n\n@keyframes xpFlyUp {\n  0% { opacity: 1; transform: translateY(0); }\n  70% { opacity: 1; }\n  100% { opacity: 0; transform: translateY(-40px); }\n}\n\n/* Responsive: 800px breakpoint */\n@media (max-width: 800px) {\n  .container {\n    padding: 0 8px;\n  }\n\n  .title {\n    font-size: 22px;\n  }\n\n  .statsGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .streakNumbers {\n    gap: 24px;\n  }\n\n  .weekCalendar {\n    gap: 4px;\n  }\n\n  .achievementGrid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 8px;\n  }\n\n  .moduleRow {\n    gap: 8px;\n  }\n\n  .moduleLabel {\n    min-width: 100px;\n    font-size: 12px;\n  }\n\n  .popupCard {\n    width: 90vw;\n    max-width: 340px;\n    padding: 24px 16px;\n  }\n}\n\n/* Responsive: 480px phone breakpoint */\n@media (max-width: 480px) {\n  .title {\n    font-size: 20px;\n  }\n\n  .titleRow {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .statsGrid {\n    grid-template-columns: 1fr 1fr;\n    gap: 8px;\n  }\n\n  .statCard {\n    padding: 10px 6px;\n  }\n\n  .statValue {\n    font-size: 20px;\n  }\n\n  .levelSection {\n    padding: 12px;\n  }\n\n  .levelBadge {\n    width: 40px;\n    height: 40px;\n  }\n\n  .levelNumber {\n    font-size: 16px;\n  }\n\n  .streakNumbers {\n    gap: 16px;\n  }\n\n  .streakValue {\n    font-size: 24px;\n  }\n\n  .achievementGrid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 6px;\n  }\n\n  .achievementIcon {\n    font-size: 22px;\n  }\n\n  .achievementName {\n    font-size: 10px;\n  }\n\n  .moduleLabel {\n    flex: 0 0 auto;\n    min-width: 0;\n    max-width: 120px;\n    font-size: 11px;\n  }\n\n  .popupCard {\n    width: 92vw;\n    padding: 20px 12px;\n  }\n\n  .popupIcon {\n    font-size: 40px;\n  }\n\n  .popupName {\n    font-size: 18px;\n  }\n\n  .xpFloat {\n    right: 12px;\n    font-size: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `cMPAZebI`,
	"title": `nEgbq2KX`,
	"titleRow": `ncAPhCxX`,
	"exportImport": `q3ykSRPe`,
	"exportBtn": `UKl_PQsL`,
	"importBtn": `qDC4mp5i`,
	"sectionTitle": `dpVt5WWr`,
	"overallSection": `wjve9IAi`,
	"overallLabel": `YjV7majH`,
	"overallBar": `ZbGwGhiB`,
	"overallFill": `KV3g_R4f`,
	"levelSection": `oMy3yFof`,
	"levelBadge": `Qp1jBRw5`,
	"levelNumber": `j95TqZAD`,
	"levelInfo": `hdzhmoj1`,
	"levelTitle": `BWgxGmtC`,
	"xpBar": `PsILvukL`,
	"xpFill": `iUznFBIr`,
	"xpLabel": `sSs0dLsW`,
	"statsGrid": `pjsUyiaY`,
	"statCard": `kHkQPAPi`,
	"statValue": `zn2kMyIq`,
	"statLabel": `CKPOunuY`,
	"streakSection": `mu7J_RfH`,
	"streakNumbers": `hH9V9if9`,
	"streakCurrent": `R_1U1J62`,
	"streakBest": `Ov8QijGQ`,
	"streakValue": `aj1bZ2wO`,
	"streakLabel": `hXd74Nu_`,
	"weekCalendar": `IFxthpIN`,
	"weekDay": `pUIqtZu3`,
	"weekDayLabel": `ADwMiBd1`,
	"weekDot": `ljUIhwrd`,
	"weekDotActive": `hajjwVvK ljUIhwrd`,
	"achievementsSection": `NECS1Qxz`,
	"achievementGrid": `MWjwoYbT`,
	"achievementCard": `JmlOb8bA`,
	"achievementCardEarned": `ndHklO4X JmlOb8bA`,
	"achievementShareWrap": `j0fvtZ5S`,
	"achievementIcon": `hoATjGPE`,
	"achievementName": `OVGSNu91`,
	"modulesSection": `dz2CncER`,
	"moduleRow": `M0UMPhyv`,
	"moduleLabel": `Uh2aPNTj`,
	"moduleBar": `qyu50iKh`,
	"moduleFill": `b2acV23W`,
	"moduleCount": `nubRmre5`,
	"popupOverlay": `NkjMmxYC`,
	"fadeIn": `Cx6M33Yg`,
	"popupCard": `cls8n1NV`,
	"popIn": `NAM7rxco`,
	"popupIcon": `_rDaUFSw`,
	"popupTitle": `jHGasSob`,
	"popupName": `xtXhQBpg`,
	"popupDesc": `Lq73Cmq_`,
	"popupXp": `ysZEEfho`,
	"popupBtn": `ooYlLMpp`,
	"popupCounter": `lCfimCFw`,
	"xpFloat": `Ijpf5adI`,
	"xpFlyUp": `AU8LwcZB`
};
export default ___CSS_LOADER_EXPORT___;
